import { useTocElement, useTocElementState } from "@platejs/toc/react";
import type { PlateElementProps } from "platejs/react";
import { PlateElement } from "platejs/react";
import { cn } from "@/lib/utils";

export function TocElement({ children, className, ...props }: PlateElementProps) {
	const state = useTocElementState();
	const { props: tocProps } = useTocElement(state);
	const headings = state.headingList;

	return (
		<PlateElement {...props} className={cn("my-4 rounded-lg border bg-muted/30 p-4", className)}>
			<div contentEditable={false}>
				<p className="mb-2 text-sm font-semibold text-muted-foreground">Table of Contents</p>
				<nav>
					{headings.map((heading) => (
						<a
							key={heading.id}
							href={`#${heading.id}`}
							className="block py-0.5 text-sm text-primary/80 hover:text-primary"
							style={{ paddingLeft: `${(heading.depth - 1) * 16}px` }}
							onClick={(e) => tocProps.onClick(e, heading, "smooth")}
						>
							{heading.title}
						</a>
					))}
					{headings.length === 0 && (
						<p className="text-sm text-muted-foreground">No headings found.</p>
					)}
				</nav>
			</div>
			{children}
		</PlateElement>
	);
}
